module.exports = __webpack_public_path__ + "images/stickers/frown@2x.d43b636515d230e0e1ad.png";